import React, { useState } from "react";

const Pagination = ({
  currentPage,
  totalRecords,
  pageSize,
  totalPages,
  startItem,
  endItem,
  onPageChange,
  onPageSizeChange,
}) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="table-responsive">
            <div
              id="order-listing_wrapper"
              className="dataTables_wrapper dt-bootstrap4 no-footer"
            >
              <div className="row">
                <div className="col-sm-12 col-md-7">
                  <div className="row">
                    <div className="col-sm-6">
                      <div
                        className="dataTables_info"
                        id="order-listing_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {startItem} to {endItem} of {totalRecords}{" "}
                        entries{" "}
                        {/* Replace "10" with the number of items per page */}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <select
                        className="form-control"
                        type="number"
                        onChange={onPageSizeChange}
                        value={pageSize}
                        style={{ width: "auto" }}
                      >
                        <option value="10">Show 10</option>
                        <option value="15">Show 15</option>
                        <option value="20">Show 20</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-5">
                  <div
                    className="dataTables_paginate paging_simple_numbers"
                    id="order-listing_paginate"
                  >
                    <ul className="pagination">
                      {/* Render the "Previous" button */}
                      <li
                        className={`paginate_button page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                        id="order-listing_previous"
                        // onClick={() => handlePageChange(currentPage - 1)}
                        onClick={() => {
                          if (currentPage !== 1) {
                            onPageChange(1);
                          }
                        }}
                        disabled={currentPage === 1}
                      >
                        <button
                          // href="#"
                          aria-controls="order-listing"
                          data-dt-idx="0"
                          tabIndex="0"
                          className="page-link"
                        >
                          <i
                            className="fa fa-angle-double-left"
                            style={{
                              height: "4px",
                              width: "4px",
                            }}
                          ></i>
                        </button>
                      </li>
                      <li
                        className={`paginate_button page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                        id="order-listing_previous"
                        // onClick={() => handlePageChange(currentPage - 1)}
                        onClick={() => {
                          if (currentPage !== 1) {
                            onPageChange(currentPage - 1);
                          }
                        }}
                        disabled={currentPage === 1}
                      >
                        <button
                          // href="#"
                          aria-controls="order-listing"
                          data-dt-idx="0"
                          tabIndex="0"
                          className="page-link"
                        >
                          <i
                            className="fa fa-chevron-left"
                            style={{
                              height: "4px",
                              width: "4px",
                            }}
                          ></i>
                        </button>
                      </li>

                      {/* Render the current page number */}
                      <li className="paginate_button page-item active">
                        <p aria-controls="order-listing" className="page-link">
                          Page {currentPage} of {totalPages}
                        </p>
                      </li>

                      {/* Render the "Next" button */}
                      <li
                        className={`paginate_button page-item ${
                          currentPage * pageSize >= totalRecords 
                            ? "disabled"
                            : ""
                        }`}
                        id="order-listing_next"
                        // onClick={() => handlePageChange(currentPage + 1)}
                        onClick={() => {
                          if (currentPage * pageSize < totalRecords) {
                            onPageChange(currentPage + 1);
                          }
                        }}
                        // disabled={currentPage * pageSize >= totalRecords} 
                      >
                        <button
                          // href="#"
                          aria-controls="order-listing"
                          data-dt-idx="2"
                          tabIndex="0"
                          className="page-link"
                        >
                          <i
                            className="fa fa-chevron-right"
                            style={{ height: "4px", width: "4px" }}
                          ></i>
                        </button>
                      </li>
                      <li
                        className={`paginate_button page-item ${
                          currentPage * pageSize >= totalRecords
                            ? "disabled"
                            : ""
                        }`}
                        id="order-listing_next"
                        // onClick={() => handlePageChange(currentPage + 1)}
                        onClick={() => {
                          if (currentPage !== totalPages) {
                            onPageChange(totalPages);
                          }
                        }}
                        // disabled={currentPage * pageSize >= totalRecords}
                      >
                        <button
                          // href="#"
                          aria-controls="order-listing"
                          data-dt-idx="2"
                          tabIndex="0"
                          className="page-link"
                        >
                          <i
                            className="fa fa-angle-double-right"
                            style={{ height: "4px", width: "4px" }}
                          ></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pagination;
